import React from 'react'
import { ButtonHLPure, ContractBulletPure } from '../../pures'
import { Checkbox } from '@progress/kendo-react-inputs'
import './on-boarding-terms-conditions.css'


const OnboardingTermsConditionsView = ({
  t,
  onBackStep,
  showErrorTerms,
  messageErrorTerms,
  openModalTermsCond,
  termsAndConditions,
  handleSaveUserData,
  toggleErrorRequesting,
  onAcceptTermsAndConditions
}) => {

  const handleSave = () => {
    if (!termsAndConditions) {
      toggleErrorRequesting(t('newUserOnboardingAction.errors.terms.required'), 4000, false, true)
      return
    }
    handleSaveUserData()
  }

  return (
    <div className='onboardingTermsConditionsView-container'>
      <ContractBulletPure {...{ t, openModalTermsCond }} />
      <div className='onboardingTermsConditionsView-checkbox'>
        <Checkbox
          id={'termsAndConditions'}
          label={t('contractBulletActionPure.termsCondition')}
          value={termsAndConditions}
          onChange={onAcceptTermsAndConditions}
        />
        {showErrorTerms && (
          <span className='onboardingTermsConditionsView-error'>{messageErrorTerms}</span>
        )}
      </div>

      <div className='onboardingTermsConditionsView-btns'>
        <ButtonHLPure
          nameBtn={t('button.return')}
          primary={false}
          onClickBtn={() => onBackStep()}
        />
        <ButtonHLPure
          nameBtn={t('button.save')}
          primary={true}
          onClickBtn={handleSave}
        />
      </div>
    </div>
  )
}

export { OnboardingTermsConditionsView as default }